@for (i of items; track i) {
  <h2 [attr.id]="getItemId(i)" translate="terms.item{{ i }}.title"></h2>
  <p [innerHTML]="getItemTextKey(i) | translate | safeHtml"></p>
}
